@if (item(); as item) {
    @if (child(); as child) {
        <button
            class="p-5 py-4 flex flex-col gap-2 border rounded-xl w-full transition-colors hover:bg-[#F4FAFD]"
        >
            <div class="flex gap-2 items-center">
                <p class="text-gray-800">{{ child.name }}</p>
                <div class="bg-gray-200 w-px h-3"></div>
                <p class="text-gray-800 text-sm">
                    {{ child.gender === "MALE" ? "남" : "여" }}
                </p>
                <p class="text-gray-400 text-sm">
                    {{ child.birth | date: "yy.MM.dd" }} ({{ child.koreanAge }})
                </p>
            </div>
            <div class="flex w-full justify-between items-center">
                <div class="flex gap-2 items-center">
                    <app-icon
                        name="material-symbols:call"
                        class="text-primary !size-4"
                    />
                    @if (child?.contact; as contact) {
                        <p class="text-sm text-gray-600">
                            {{ contact | contact }}
                        </p>
                    } @else {
                        -
                    }
                </div>
                <div class="flex gap-2 items-center">
                    <p class="text-sm text-gray-600">
                        서비스
                        <span class="ml-1 text-primary">{{
                            tickets()?.length || 0
                        }}</span>
                    </p>
                    <app-icon
                        name="material-symbols:arrow-forward-ios"
                        class="text-gray-400 !size-3"
                    />
                </div>
            </div>
        </button>
    }
}
